import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import VideoEditIcon from "../../../assets/VideoEditing/icons/VideoEditIcon";
import { useAppStore } from "../../../hooks/useStores";
import LabResults from "../../../layout/LabsLayout/Results/LabResults";
import { PlaygroundImage } from "../../../models/playground";
import { useFiboController } from "../../Fibo/hooks/useFiboController";
import { useScrollToSection } from "../../Fibo/hooks/useScrollToSection";
import { PlaygroundVideoProps } from "../../Playground/VideoGeneration/Video/PlaygroundVideo";
import LabExperiments from "../Experiments/LabExperiments";
import VideoEditingConfig from "./Config/VideoEditingConfig";
import styles from "./VideoEditingLab.module.scss";

const VideoEditingLab = () => {
	const { registerSection, jumpToSection } = useScrollToSection();
	const { playgroundStore } = useAppStore();
	const { handleResultInView, handleReferenceImageClick, handleJumpTo } = useFiboController();

	return (
		<Box className={styles.container}>
			<Box className={styles.mainContent}>
				<VideoEditingConfig />
				<LabResults
					onResultInView={handleResultInView}
					registerSection={registerSection}
					onReferenceImageClick={handleReferenceImageClick}
					emptyElement={<EmptyResultsPlaceholderElement />}
				/>
			</Box>

			{playgroundStore.labResultGroups.length > 0 && (
				<LabExperiments
					activeGroupId={playgroundStore.selectedResult?.id || undefined}
					onJumpTo={(resultId: string, selectedImage: PlaygroundImage | PlaygroundVideoProps) =>
						handleJumpTo(resultId, selectedImage, jumpToSection)
					}
				/>
			)}
		</Box>
	);
};

export default observer(VideoEditingLab);

const EmptyResultsPlaceholderElement = () => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.results.emptyPlaceholder" });

	return (
		<Box className={styles.emptyResultsPlaceholderElement}>
			<VideoEditIcon className={styles.imageEditIcon} />
			<Typography className={styles.title}>{t("title")}</Typography>
			<Trans>
				<Typography className={styles.description}>{t("description")}</Typography>
			</Trans>
		</Box>
	);
};
